import * as React from "react";
import * as ReactDOM from "react-dom";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { dialogContainerElement } from "../../../core";
import { IState } from "../../redux";
import { generic } from "../../../ui/_themes/constants";

export const Wrapper = styled.div`
  pointer-events: all;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${generic.uiBlocker.overlayColor};
  z-index: ${generic.layers.uiBlocker};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UiBlocker = () => {
  const uiBlockerState = useSelector((state: IState) => state.uiBlocker);

  const isViewBlocked = uiBlockerState.enabled;

  if (!isViewBlocked) {
    return null;
  }
  return ReactDOM.createPortal(<Wrapper />, dialogContainerElement);
};
